<template>
  <div class="flex flex-wrap gap-2 mb-4">
    <span
      class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium"
      :class="getStatusBadgeClass(order.status)"
    >
      {{ $t('app.status.' + order.status) }}
    </span>
    <span
      class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium"
      :class="order.is_paid ? 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-200' : 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-200'"
    >
      {{ order.is_paid ? $t('app.views.orders.payment.paid') : $t('app.views.orders.payment.pending') }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

interface Props {
  order: {
    status: string
    is_paid: boolean
  }
}

const props = defineProps<Props>()
const { t } = useI18n()

const getStatusBadgeClass = (status: string) => {
  switch (status) {
    case 'pending':
      return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-200'
    case 'confirmed':
      return 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-200'
    case 'preparing':
      return 'bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-200'
    case 'ready':
      return 'bg-indigo-100 text-indigo-800 dark:bg-indigo-900/30 dark:text-indigo-200'
    case 'served':
      return 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-200'
    case 'completed':
      return 'bg-gray-100 text-gray-800 dark:bg-gray-900/30 dark:text-gray-200'
    case 'cancelled':
      return 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-200'
    default:
      return 'bg-gray-100 text-gray-800 dark:bg-gray-900/30 dark:text-gray-200'
  }
}
</script>
